/**
 * Предел клиентского каталога по табличному расходу м³/ч (не по номиналу кВт).
 */

import {
  HYDRAULIC_SEPARATOR_CLIENT_POWER_STEPS,
  HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE,
} from './hydraulicSeparatorClientParams';
import {
  DISTRIBUTION_COLLECTOR_CLIENT_PARAMS_TABLE,
  DISTRIBUTION_COLLECTOR_CLIENT_POWER_STEPS,
} from './distributionCollectorClientParams';

function maxTableFlowM3hFromParamsTable(paramsTable, powerSteps, shape) {
  let maxQ = null;
  for (const stepKw of powerSteps) {
    const row = paramsTable[stepKw];
    if (!row || row.flowRate == null) continue;
    if (shape === 'square' && !row.squareProfile) continue;
    const q = Number(row.flowRate);
    if (!Number.isFinite(q)) continue;
    if (maxQ == null || q > maxQ) maxQ = q;
  }
  return maxQ;
}

export function getHydraulicSeparatorClientMaxTableFlowM3h(shape = 'round') {
  return maxTableFlowM3hFromParamsTable(
    HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE,
    HYDRAULIC_SEPARATOR_CLIENT_POWER_STEPS,
    shape
  );
}

export function getDistributionCollectorClientMaxTableFlowM3h(shape = 'round') {
  return maxTableFlowM3hFromParamsTable(
    DISTRIBUTION_COLLECTOR_CLIENT_PARAMS_TABLE,
    DISTRIBUTION_COLLECTOR_CLIENT_POWER_STEPS,
    shape
  );
}

/** Свыше каталога: расход строго больше максимального табличного для сечения. */
export function isClientFlowM3hOverCatalogTable(flowM3h, maxTableFlowM3h) {
  const q = Number(flowM3h);
  const maxQ = Number(maxTableFlowM3h);
  if (!Number.isFinite(q) || q <= 0) return false;
  if (!Number.isFinite(maxQ) || maxQ <= 0) return false;
  return q > maxQ + 1e-6;
}
